/** Maps a Cognito error to the message shown on the login page (Angular LoginComponent.messageFor). */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function loginErrorMessage(error: any): string {
  switch (error?.code ?? error?.name) {
    case 'NotAuthorizedException':
    case 'UserNotFoundException':
      return 'Incorrect username or password.';
    case 'PasswordResetRequiredException':
      return 'Your password has to be reset. Please contact your administrator.';
    case 'UserNotConfirmedException':
      return 'This account has not been confirmed yet.';
    case 'TooManyRequestsException':
    case 'LimitExceededException':
      return 'Too many attempts. Please wait a moment and try again.';
    case 'InvalidPasswordException':
    case 'InvalidParameterException':
      return error?.message || 'That password is not acceptable.';
    case 'NetworkError':
      return 'We could not reach the sign-in service. Check your connection and try again.';
    default:
      return error?.message || 'Something went wrong. Please try again.';
  }
}

/** Only same-app paths: a full URL here would let a crafted link bounce the user elsewhere. */
export function safeReturnUrl(returnUrl: string | null): string {
  const safe = returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//');
  return safe ? returnUrl : '/home/dashboard';
}

export const NO_TENANT_MESSAGE =
  'This account is not set up for Capium Accounts Production. Please contact your administrator.';
